export default __webpack_public_path__ + "static/media/slide8.fd1a6672.webp";